import React, { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import SectionOne from './components/SectionOne';
import Features from './components/Features';
import OfferPromotion from './components/OfferPromotion';
import CinematicGrid from './components/CinematicGrid';
import Contact from './components/Contact';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';

function App() {
  useEffect(() => {
    const removeGretaBadge = () => {
      // Look for all elements in the body
      const allElements = document.querySelectorAll('body *');

      allElements.forEach((el) => {
        // Skip if the element is part of our root app to be safe
        const root = document.getElementById('root');
        if (root && root.contains(el)) return;

        const text = el.textContent?.toLowerCase() || '';
        const href = el.getAttribute?.('href')?.toLowerCase() || '';
        const className = el.className?.toString().toLowerCase() || '';
        const id = el.id?.toLowerCase() || '';
        const ariaLabel = el.getAttribute?.('aria-label')?.toLowerCase() || '';

        const rect = el.getBoundingClientRect?.();
        const isBottomRight =
          rect &&
          rect.width > 0 &&
          rect.height > 0 &&
          rect.right > window.innerWidth - 200 &&
          rect.bottom > window.innerHeight - 150;

        const looksLikeGretaBadge =
          text.includes('built with greta') ||
          text.includes('greta') ||
          href.includes('greta') ||
          className.includes('greta') ||
          id.includes('greta') ||
          ariaLabel.includes('greta') ||
          className.includes('badge') ||
          id.includes('badge');

        if (looksLikeGretaBadge && isBottomRight) {
          el.style.display = 'none';
          el.remove();
        }
      });
    };

    // Run immediately
    removeGretaBadge();

    // Run at intervals to catch late injections
    const interval = setInterval(removeGretaBadge, 1000);

    // Observe body for any new nodes being added
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(() => removeGretaBadge());
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="min-h-screen bg-ivory overflow-x-hidden selection:bg-gold/30 selection:text-olive">
      <Header />
      <main>
        <Hero />
        <SectionOne />
        <Features />
        <OfferPromotion />
        <CinematicGrid />
        <Contact />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}

export default App;